export const BREAKPOINTS = {
    mobile: 768,
    tablet: 1024,
};
export const BREAKPOINTS_DETAILED = {
    mobile: 768,
    tablet: 1024,
    desktop_s: 1440,
    desktop_m: 1920,
};
